module.exports = __webpack_public_path__ + "img/ramp-loading.9a20f174.svg";